import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { setupPreconnects } from "./lib/preconnect";

// Run before the first paint so the browser opens connections to the CDN
// and font origins as early as possible.
setupPreconnects();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-372" data-mp="2aavy80uotmh3" />);
}